import { FormProvider, useForm } from 'react-hook-form';
import * as React from 'react';
import ControlledInput from '../../components/ControlledInput';
import BtnFilled from '../../components/BtnFilled';
import Edit from '@mui/icons-material/Edit';
import { ERROR_TEXT } from '../../constants';
import { getUserApi, updateUser } from '../../api/api';
import Modal from '../../components/Modal';
import { useUserStore } from '../../stores';
import { toast } from 'react-toastify';
import { useState } from 'react';
import useThrottle from '../../utils/use-throttle';
import EditEmailForm from './EditEmailForm';

const EditAccountForm = () => {
  const { user, setUser, setAuthorized } = useUserStore();
  const methods = useForm({
    mode: 'onChange',
    defaultValues: { fio: user.fio || '', phone: user.phone || '' },
  });
  const [showModal, setShowModal] = useState(false);

  const handleSuccess = async () => {
    toast.success('Данные успешно обновлены!');
    await getUserApi(
      function (data) {
        setUser(data);
        setAuthorized(true);
      },
      function () {
        setAuthorized(false);
      }
    );
    setShowModal(false);
  };

  const handleError = (err) => {
    toast.error(err?.error || 'Произошла ошибка при обновлении');
    setShowModal(false);
  };

  const handleSubmit = useThrottle(async (data) => {
    const { phone, ...rest } = data;
    const formData = { ...rest, phone: phone.replace(/\s+/g, '') };
    await updateUser(formData, handleSuccess, handleError);
  }, 500);

  const inputs = [
    { name: 'fio', label: 'ФИО', placeholder: 'Иванов Иван Иванович', type: 'text' },
    { name: 'phone', label: 'Номер телефона', placeholder: '+7 945 564 923 56', type: 'text', mask: '+7 999 999 99 99' },
  ];

  return (
    <>
      <button
        className={'absolute hover:bg-orange-500 transition right-4 top-4 flex justify-center items-center bg-black w-10 h-10 rounded-xl'}
        onClick={() => setShowModal(true)}>
        <Edit className="text-white" />
      </button>
      <Modal showSave={false} showModal={showModal} setShowModal={setShowModal} title={'Обновить профиль'}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleSubmit)}>
            {inputs.map((input) => {
              const generalProps = {
                classContainer: 'mb-4',
                rules: {
                  required: {
                    value: input.required,
                    message: ERROR_TEXT.REQUIRED,
                  },
                },
              };
              return <ControlledInput key={input.name} {...generalProps} {...input} />;
            })}
            <EditEmailForm />
            <BtnFilled className={'flex justify-center max-w-[220px] m-auto'} color={'bg-orange-500'} type={'submit'} title="Cохранить изменения" />
          </form>
        </FormProvider>
      </Modal>
    </>
  );
};

export default EditAccountForm;
